import React, {useEffect, useState} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';

import {Descriptions, message, Spin} from 'antd';
import {findRequestById} from 'services/RequestService';
import {handleError} from 'utils/MessageUtils';

const DiagnosticInfo = (props) => {
  const {keycloak} = useKeycloak();
  const intl = useIntl();

  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const {requestId} = props;

  const [request, setRequest] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (requestId?.length > 0) {
      setLoading(true);
      findRequestById(headers, requestId)
        .then((res) => {
          setRequest(res.data);
        })
        .catch((error) => handleError(message, error))
        .finally(() => setLoading(false));
    }
  }, [requestId]);

  return (
    <Spin spinning={loading}>
      <Descriptions bordered size='middle' style={{padding: 10}} column={2}>
        <Descriptions.Item label={intl.messages['diagnostic.disease']} span={2}>
          {request?.diagnostic?.disease?.name}
        </Descriptions.Item>
        <Descriptions.Item
          label={intl.messages['diagnostic.conclusion']}
          span={2}>
          {request?.diagnostic?.conclusion}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['diagnostic.note']} span={2}>
          {request?.diagnostic?.note}
        </Descriptions.Item>
      </Descriptions>
    </Spin>
  );
};

export default DiagnosticInfo;

DiagnosticInfo.propTypes = {
  requestId: PropTypes.string,
};
